import React from 'react';
import 'semantic-ui-css/semantic.min.css';
import ReportModelBase from '../ReportModelBase';
import { Table } from 'semantic-ui-react';

class EmployeeReportModelGroupByPosition extends ReportModelBase {

    constructor(props){
        super(props);
        this.searchUrl = "api/Reports/employeeReportGroupByPosition";
        this.title = "Employee Report Group by Position";
        this.exportToExcelUrl = "api/Reports/ExportEmployeeReportGroupByPositionToExcel";
        this.exportToPdfUrl = "api/Reports/ExportEmployeeReportGroupByPositionToPDF";
    }

    toTableRow = (rowData) => {
        return (
            <Table.Row>
                <Table.Cell>{rowData["Employee No"]}</Table.Cell>
                <Table.Cell>{rowData["Employee"]}</Table.Cell>
                <Table.Cell>{rowData["Position"]}</Table.Cell>
            </Table.Row>
        );
    }

    createColumnHeaders = () => {
        return (
            <Table.Row>
                <Table.HeaderCell>Employee No</Table.HeaderCell>
                <Table.HeaderCell>Employee</Table.HeaderCell>
                <Table.HeaderCell>Position</Table.HeaderCell>
            </Table.Row>
        );
    }

}
export default EmployeeReportModelGroupByPosition;